import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
    standalone: true,
    name: 'calculateAge',
    
})
export class CalculateAgePipe implements PipeTransform {
  transform(birthday: string): string {
    const today = dayjs();
    const birthdate = dayjs(birthday);
    if (!birthdate.isValid()) {
      return '--';
    }
    return today.diff(birthdate, 'year').toString();
  }

}
